// extracted by mini-css-extract-plugin
export var fullHeightState = "_6x-7";
export var headerCell = "_6x-1";
export var loadingStateCell = "_6x-4";
export var rowWrapper = "_6x-3";
export var standaloneTable = "_6x-8";
export var standaloneTableWithBodyFill = "_6x-9";
export var stateCell = "_6x-5";
export var table = "_6x-0";
export var tableBodyFiller = "_6x-6";
export var white = "_6x-2";